import team_image_1 from '@/images/gallery/team_image_1.jpg'
export default {
  "header": {
    "support": "Support Us",
    "phone": "(+228) 79569276 / 90858351",
    "email": "Email: associationdaideauxhandicapesh@gmail.com / aplahaplah02@gmail.com",
    "language": "Language",
    "languages": {
      "arabic": "Arabic",
      "french": "French", 
      "english": "English"
    },
    "menu": {
      "home": "Home",
      "objectives": "Objectives",
      "about": "About",
      "leaders": "Leaders",
      "gallery": "Gallery",
      "contact": "Contact"
    },
    "donate": "Donate Now"
  },
  "banner": {
    "title1": "Let's unite",
    "title2": "to support those in need",
    "title3": "Building an inclusive world,",
    "title4": "one step at a time"
  },
  "about": {
  "title": "About the Association for Helping Muslims in Difficulty",
  "description": "The Association for Helping Disabled Muslims (AS.A.HA.M) is a non-governmental organization founded by Muslims and committed youth in the Plateaux region of the Republic of Togo. It works to uphold human dignity and implements concrete actions to meet the specific needs of communities, particularly those of people in difficulty.",
  "origin": {
    "title": "Origin and Foundation",
    "items": [
      "Created in a spirit of Islamic and humanitarian solidarity.",
      "Founded with the primary goal of addressing the challenges faced by people in difficulty.",
      "Aimed at being progressively deployed on a national and regional scale, particularly in West Africa."
    ]
  },
  "mission": {
    "title": "Mission and Values",
    "items": [
      "Main mission: To improve the quality of life of people in difficulty while supporting their social and economic inclusion.",
      "Core values: Respect for human dignity, community solidarity, and patriotic responsibility."
    ]
  },
  "vision": {
    "title": "Vision of the Founders",
    "items": [
      "To work in a spirit of common service within the Islamic and patriotic society.",
      "To show commitment to religious, social, and human responsibilities in their activities."
    ]
  }
}

  ,
  "objectives": {
    "title": "Objectives",
    "items": [
      {
        "title": "Education centers",
        "description": "Establish educational centers accessible to all generations."
      },
      {
        "title": "Access to drinking water",
        "description": "Build wells and boreholes in rural and urban areas to improve social and human development."
      },
      {
        "title": "Promotion of universal languages", 
        "description": "Encourage learning Arabic, French and English languages for better integration and global communication."
      },
      {
        "title": "Training and empowerment",
        "description": "Organize seminars and practical work to encourage autonomous development in public and private sectors."
      },
      {
        "title": "Strengthening fraternal relations",
        "description": "Promote collaboration between Islamic and non-Islamic associations for common goals, including the promotion of Islamic culture."
      }
    ]
  },
  "achievements": {
    "title": "Our Achievements"
  },
  "gallery": {
    "title1": "AS.A.HA.M Gallery Images",
    "title2": "AS.A.HA.M & Matw Project Partnership Images",
    "filters": {
      "all": "All",
      "medical": "Mosques",
      "mosque": "Mosques",
      "shelter": "Boreholes",
      "water": "Water",
      "donation": "Donations",
      "well": "Wells"
    }
  },
  "leaders": {
    "title": "Leaders",
    "members": [
      {
        "name": "ALI Tairou Abd Haddi",
        "position": "President",
        "photo":team_image_1
      },
      {
        "name": "IDRISSOU Abdourachid",
        "position": "General Secretary",
        "photo":team_image_1
      },
      {
        "name": "TCHA KOURA Zouberou",
        "position": "Projects Delegate",
        "photo":team_image_1
      },
      {
        "name": "DJIBRILA SOUMAYATOU",
        "position": "Accountant",
        "photo":team_image_1
      }
    ]
  },
  "contact": {
    "title": "Contact Us",
    "subtitle": "Working Together To Make a Difference",
    "form": {
      "name": "Your Name",
      "email": "Email",
      "phone": "Phone",
      "help": "How can we help you?",
      "message": "Message",
      "submit": "Send Message"
    },
    "address": "PO Box: 361 kpalimé Togo",
    "phone": "Phone (+228) 79569276 / 90858351",
    "email": "associationdaideauxhandicapesh@gmail.com"
  },
  "footer": {
    "newsletter": {
      "title": "Subscribe to our newsletter for updates",
      "placeholder": "Enter your email",
      "button":"Send"
    },
    "copyright": "Copyright (c) 2024 AS.A.HA.M. All rights reserved."
  }
}